import api from "@/config/apiConfig";

class ReceivableController {
  async summary() {
    const r = await api.get("/receivables/summary");
    return r.data;
  }

  async index(filters = {}) {
    const r = await api.get("/receivables", { params: filters });
    return r.data;
  }

  async findOne(id) {
    const r = await api.get(`/receivables/${id}`);
    return r.data;
  }
}

export default new ReceivableController();
